module.exports = __webpack_public_path__ + "img/double-image-hero-cjdr.63ac771f.jpg";